(function ($, Cobalt, undefined) {
    Cobalt.Achievement = {
        initialize: function () {
            $('[data-action=delete-achievement]').click(function () {
                if (prompt('Are you sure you want to delete this achievement? Everyone who has earned it will be unawarded it. This action cannot be undone. Type "DELETE" if you are sure.') != 'DELETE')
                    return;
                var id = $(this).data('id');
                Cobalt.Utils.getRequestVerificationToken().done(function(token) {
                    $.post('/cp/achievements/delete/' + id,
                        { 'request-verification-token': token },
                        function(data) {
                            if (data.Success)
                                location.reload();
                        });
                });
            });

            $('#field-trigger').change(function () {
                Cobalt.Achievement.onTriggerChange();
            });

            $('#field-req-amount').change(function () {
                Cobalt.Achievement.onTriggerChange();
            });

            Cobalt.Achievement.onTriggerChange();

            Cobalt.Achievement.notify();

            Cobalt.runOnHtmlInsert(Cobalt.Achievement.setupTooltips);
        },

        initalizetUserAchievementStats: function (perUserAchievements) {
            $('.p-achievement-details').each(function () {
                var $this = $(this);

                var $a = $this.find('> a'),
                    $div = $a.find('> div'),
                    id = $a.data('id'),
                    achievement = Cobalt.Achievement.Data.Earned[id];

                if ($a.data('req-amount') > 0 && !perUserAchievements) {
                    $div.addClass('p-achievement-has-progress-bar').append($('<span>').addClass('p-achievement-progress-bar'));
                }

                if (achievement !== undefined) {
                    if (perUserAchievements)
                        $this.attr('data-count', achievement.Earned);

                    if ($a.data('req-amount') > 0 && !perUserAchievements) {
                        if (achievement.Progress) {
                            $div.find('span.p-achievement-progress-bar').width(((achievement.Progress / $a.data('req-amount')) * 100) + '%');
                        }
                    }
                }

                var count = parseInt($(this).data('count')) || parseInt($(this).parent().data('count'));
                if (count > 1 || ($(this).data('always-display-count') && count > 0))
                    $a.append($('<figure>').html('&times;' + $(this).data('count').toCommaThousands()));
            });
        },

        writeAchievementCounts: function () {
            var gold = parseInt(Cobalt.Achievement.Data.Counts.GoldAchievements) || 0;
            var silver = parseInt(Cobalt.Achievement.Data.Counts.SilverAchievements) || 0;
            var bronze = parseInt(Cobalt.Achievement.Data.Counts.BronzeAchievements) || 0;

            document.write('<ul class="p-achievement p-achievement-user-count tip">');
            if (gold > 0)
                document.write('<li class="p-achievement-user-count-tier-3">' + gold + '</li>');
            if (silver > 0)
                document.write('<li class="p-achievement-user-count-tier-2">' + silver + '</li>');
            if (bronze > 0 || (gold == 0 && silver == 0))
                document.write('<li class="p-achievement-user-count-tier-1">' + bronze + '</li>');

            document.write('</ul>');
        },

        onTriggerChange: function () {
            var option = $('#field-trigger option:selected');

            if (option.length == 0)
                return;

            var triggerHelp = option.attr('data-trigger-help') || null;
            var amountHelp = option.attr('data-amount-help') || null;
            var stringDataHelpHelp = null;
            var amount = $('#field-req-amount').val().length == 0 ? null : parseInt($('#field-req-amount').val());

            if (option.attr('data-req-string') == 'true') {
                stringDataHelpHelp = amountHelp;
                amountHelp = null;
            }

            if (amount != null && triggerHelp != null)
                triggerHelp = triggerHelp.replace('$a', amount);

            if (triggerHelp)
                $('#trigger-help').text(triggerHelp).show();
            else
                $('#trigger-help').hide();

            if (amountHelp) {
                $('#amount-help').text(amountHelp).show().parents('tr').show();
            } else {
                $('#amount-help').hide().parents('tr').hide();
            }

            if (stringDataHelpHelp) {
                $('#string-help').text(stringDataHelpHelp).show().parents('tr').show();
            } else {
                $('#string-help').hide().parents('tr').hide();
            }

            if (option.attr('data-req-other-achievements') == 'true') {
                $('#field-required-achievements').parents('tr').show();
            } else {
                $('#field-required-achievements').parents('tr').hide();
            }

            if (option.attr('data-req-string') == 'true') {
                $('#field-string-data').parents('tr').show();
            } else {
                $('#field-string-data').parents('tr').hide();
            }

            if (option.attr('data-req-url') == 'true') {
                $('#field-url').parents('tr').show();
                $('#field-controller').parents('tr').show();
                $('#field-controller-action').parents('tr').show();
            } else {
                $('#field-url').parents('tr').hide();
                $('#field-controller').parents('tr').hide();
                $('#field-controller-action').parents('tr').hide();
            }
        },

        notify: function () {
            if (!Cobalt.Achievement.Data || !Cobalt.Achievement.Data.Pending)
                return;

            Cobalt.Achievement.displayAchievements();

            Cobalt.Achievement.Data.Pending = null;
        },

        displayAchievements: function () {
            var $achievementContainer = $('.p-achievement.p-achievement-notices'),
                containerExists = true;

            if (!$achievementContainer.length) {
                $achievementContainer = $('<div>').addClass('p-achievement p-achievement-notices');
                containerExists = false;
            }

            var aCount = 0;
            for (var k in Cobalt.Achievement.Data.Pending) {
                if (Cobalt.Achievement.Data.Pending.hasOwnProperty(k)) {
                    aCount++;
                }
            }


            $.each(Cobalt.Achievement.Data.Pending, function (i) {
                aCount--;

                var $achievement = $('<div>').addClass('p-achievement-notice p-achievement-tier-' + this.Tier);

                $achievement.append($('<h1>').addClass('p-achievement-name').text(this.Name), $('<p>').addClass('p-achievement-description').text(this.Description)).animate({ minHeight: '85px', height: 'auto', borderWidth: '2px' }, 250);;
                $achievement.delay(100 + (aCount * 250)).animate({ left: '0px' }, 600, 'easeOutBack').delay(5000 + (aCount * 250)).animate({ left: '350px' }, 600, 'easeInBack', function () { $(this).animate({ minHeight: 0, height: 0, borderWidth: 0, marginTop: 0 }, 250); });

                $achievementContainer.append($achievement);
            });

            $(document.body).on('click', '.p-achievement-notice', function () {
                location.href = '/members/' + Cobalt.User.username + '/achievements';
            });

            if (!containerExists) {
                $(document.body).append($achievementContainer);
            }
        },

        setupTooltips: function (parent) {
            parent.find('.p-achievement-details > a').each(function () {
                $(this).tooltip({ content: Cobalt.Achievement.getTooltipText, customCssClass: 'p-achievement p-achievement-tooltip' });
            });
        },

        getTooltipText: function (achievementLink) {
            var container = $('<div/>').addClass('p-achievement-tooltip-tier-' + achievementLink.data('tier')),
                title = $('<h2/>').append(achievementLink.data('name')),
                description = $('<p/>').addClass('description').text(achievementLink.data('description')),
                details = $('<p/>').addClass('details').hide(),
                earnedData = null,
                maxProgress = parseInt(achievementLink.data('req-amount')) || 0,
                reqAchievements = (achievementLink.data('req-achievements') || '').split(',');

            if (Cobalt.Achievement.Data && Cobalt.Achievement.Data.Earned && Cobalt.Achievement.Data.Earned[achievementLink.data('id')])
                earnedData = Cobalt.Achievement.Data.Earned[achievementLink.data('id')];

            if (achievementLink.data('text')) {
                details.text(achievementLink.data('text')).show();
            } else if (achievementLink.parent().data('earned-time')) {
                var count = achievementLink.parent().data('count');

                details.addClass('earned').html(((count > 1 ? 'First ' : '') + 'Earned {0}.').format(achievementLink.parent().data('earned-time'))).show();
            } else if (earnedData != null && earnedData.Earned) {
                var count = achievementLink.parent().data('count');

                details.addClass('earned').html(((count > 1 ? 'First ' : '') + 'Earned {0}.').format(earnedData.EarnedDate)).show();
            } else if (maxProgress) {
                details.addClass('progress').html('Your progress: <span>{0} / {1}</span>'.format(earnedData == null ? 0 : earnedData.Progress, maxProgress)).show();
            } else if (reqAchievements[0] != '') {
                var list = $('<ul/>');

                for (var i in reqAchievements) {
                    var reqAchievement = parseInt(reqAchievements[i]) || 0;

                    if (reqAchievement == 0)
                        continue;

                    var name = (Cobalt.Achievement && Cobalt.Achievement.Data && Cobalt.Achievement.Data.Names && Cobalt.Achievement.Data.Names[reqAchievement]) ? Cobalt.Achievement.Data.Names[reqAchievement] : null;
                    if (!name)
                        continue;

                    var earned = Cobalt.Achievement.Data.Earned[reqAchievement];

                    list.append($('<li/>').text(' ' + name).addClass(earned ? 'earned' : ''));
                }

                details.html(list).show();
            }

            container.append(title).append(description);

            if (details.isVisible())
                container.append(details);

            return container;
        },

        doAjaxCheck: function () {
            $.get('/site-achievements/ajax', null, function (result) {
                if (typeof (result) == 'object') {
                    Cobalt.Achievement.Data = result;
                    Cobalt.Achievement.notify();
                }
            });
        },

        trigger: function (triggerName) {
            Cobalt.Utils.getRequestVerificationToken().done(function(token) {
                $.post('/site-achievements/trigger',
                    { triggerName: triggerName, 'request-verification-token': token },
                    function(result) {
                        if (typeof (result) == 'object') {
                            Cobalt.Achievement.Data = result;
                            Cobalt.Achievement.notify();
                        }
                    });
            });
        },
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Achievement.js